// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"_fc50cf8","gameOverlayModal":"_b7cc8cd","mobile":"_4c9b0f3"};